import { render, staticRenderFns } from "./ReportsTabOrders.vue?vue&type=template&id=fe4ab7f4&"
import script from "./ReportsTabOrders.vue?vue&type=script&lang=js&"
export * from "./ReportsTabOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports